module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/175ekuE/tc-custom/9781497613539.jpg?1733030046456",
      "alt": "This image is the cover for the book Castle Perilous, Castle Perilous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Castle Perilous, Castle Perilous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Welcome to the wild and wacky alternate worlds fantasy series. “I’ve enjoyed every book DeChancie has written!” (Steven Brust, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Imagine life in an ironically magical world where 144,000 doors separate fiction from reality. A place that can hypnotize even the most grounded philosophy major and deliver a fantastical rhyme to his reason. A place where a best buddy resembles a shaggy carpet, and adventures surpass a boy's dreams . . . welcome to Castle Perilous.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John DeChancie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining Castle series and the Starrigger trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0